var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"id":"wrapper"}},[_c('el-header',[_c('PageTitle',{attrs:{"title":"Manage Users","disableDateTime":""}})],1),_c('el-main',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('UsersTable')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }